<template>
  <a-modal
    :title="isAdd ? '新建课程' : '修改课程'"
    :maskClosable="false"
    :width="800"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :cancelText="'取消'"
    :okText="'确定'"
    @cancel="handleCancel"
    :footer="null"
  >
    <a-spin :spinning="disabledSpin" tip="上传中，请稍后...">
      <div class="course-form">
        <!-- 如果是课程方登录，可以选择平台的课程 -->
        <template v-if="showPlatformSelect && roleId == 4">
          <div class="cousre-type-select">
            <div
              class="tab hover-font-active"
              @click="
                sourceType = '3'
                showPlatformSelect = false
              "
            >
              <div class="title">平台</div>
              <div class="desc">选择平台课程</div>
            </div>
            <div class="tab hover-font-active" @click="chooseUsCourse">
              <div class="title">自有课程</div>
              <div class="desc">新建本课程方自有的课程</div>
            </div>
          </div>
        </template>

        <template v-else>
          <a-steps :current="current">
            <a-step
              v-for="item in steps"
              :key="item.title"
              :title="item.title"
            />
          </a-steps>

          <a-form
            class="step-1 step-box"
            layout="horizontal"
            :form="form"
            v-show="current == 0"
          >
            <!-- 平台课程选择 修改这里不能选择-->
            <a-form-item
              label="平台课程选择"
              :labelCol="{ lg: { span: 7 } }"
              :wrapperCol="{ lg: { span: 13 } }"
              v-if="platformCourse && isAdd"
            >
              <a-select
                showSearch
                placeholder="请选择平台的课"
                :filterOption="false"
                @search="searchCourse"
                @change="courseChange"
                @focus="searchCourse"
                :notFoundContent="
                  searchLoading_course ? undefined : '没有查询结果'
                "
              >
                <a-spin
                  v-if="searchLoading_course"
                  slot="notFoundContent"
                  size="small"
                />
                <a-select-option v-for="d in courseList" :key="d.id">{{
                  d.courseName
                }}</a-select-option>
              </a-select>
            </a-form-item>

            <!-- 站点 管理员才有 -->
            <a-form-item
              label="站点"
              :labelCol="{ lg: { span: 7 } }"
              :wrapperCol="{ lg: { span: 13 } }"
              v-if="roleId == '6'"
            >
              <a-select
                showSearch
                class="form-cell"
                placeholder="请选择"
                :allowClear="true"
                :filterOption="false"
                @search="selectSearchBureau"
                @change="getBureauCourseSetting"
                v-decorator="[
                  'bureauId',
                  { rules: [{ required: true, message: '请选择站点' }] },
                ]"
              >
                <a-select-option
                  v-for="(item, index) in bureauList"
                  :key="index"
                  :value="item.id"
                  >{{ item.bureauName }}</a-select-option
                >
              </a-select>
            </a-form-item>

            <!-- 封面上传 -->
            <a-form-item
              label="封面上传"
              :labelCol="{ lg: { span: 7 } }"
              :wrapperCol="{ lg: { span: 13 } }"
            >
              <c-upload
                accept="image/*"
                ossType="avatar"
                :isSingle="true"
                :maxFileSize="2097152"
                @uploadSuccess="uploadSuccess"
                :sourceFileList="sourceFileList"
                :disabled="platformCourse"
              ></c-upload>
            </a-form-item>

            <!-- 课程名字 -->
            <a-form-item
              label="课程名字"
              :labelCol="{ lg: { span: 7 } }"
              :wrapperCol="{ lg: { span: 13 } }"
            >
              <a-input
                type="textarea"
                :disabled="platformCourse"
                v-decorator="[
                  'courseName',
                  {
                    rules: [
                      {
                        required: true,
                        pattern: /^.{2,45}$/,
                        message: '请输入长度为2~45位的课程名字',
                      },
                    ],
                    validateTrigger: 'change',
                  },
                ]"
              />
              <div class="shelter"></div>
            </a-form-item>

            <!-- 课程分类 -->
            <a-form-item
              label="课程分类"
              :labelCol="{ lg: { span: 7 } }"
              :wrapperCol="{ lg: { span: 13 } }"
            >
            <!-- @change="classifyIdChange" -->
              <a-select
                v-if="roleId != 4"
                placeholder="请选择"
                :disabled="platformCourse || !this.isAdd || roleId == 6"
                @change="classifyIdChange"
                v-decorator="[
                  'classifyId',
                  { rules: [{ required: true, message: '请选择' }] },
                ]"
              >
                <a-select-option
                  v-for="(item, index) in $store.getters.getClassify2"
                  :key="index"
                  :value="item.id"
                  >{{ item.tagName }}</a-select-option
                >
              </a-select>
              <!-- 课程方课程分类 -->
              <a-select
                v-else
                placeholder="请选择"
                :disabled="platformCourse || !this.isAdd"
                @change="classifyIdChange"
                v-decorator="[
                  'classifyId',
                  { rules: [{ required: true, message: '请选择' }] },
                ]"
              >
                <a-select-option
                  v-for="(item, index) in $store.getters.getClassify2"
                  :key="index"
                  :value="item.id"
                  >{{ item.tagName }}</a-select-option
                >
              </a-select>
              <span>注：仅新建课程时允许选择课程分类</span>  
            </a-form-item>

            <a-form-item
              label="课程类目"
              :labelCol="{ lg: { span: 7 } }"
              :wrapperCol="{ lg: { span: 13 } }"
            >
              <a-cascader
                :options="$store.state.common.courseCateLevel"
                :fieldNames="{
                  label: 'name',
                  value: 'id',
                  children: 'children',
                }"
                :disabled="platformCourse"
                placeholder="请选择"
                v-decorator="[
                  'cateList',
                  { rules: [{ required: true, message: '请选择课程类目' }] },
                ]"
              />
            </a-form-item>

            <!-- 适用年级 -->
            <a-form-item
              label="适用年级"
              :labelCol="{ lg: { span: 7 } }"
              :wrapperCol="{ lg: { span: 13 } }"
            >
              <a-select
                mode="multiple"
                :disabled="platformCourse"
                placeholder="请选择"
                v-decorator="[
                  'gradeScope',
                  { rules: [{ required: true, message: '请选择' }] },
                ]"
              >
                <!-- <a-select-option
                  v-for="(item, index) in $store.getters.getGradeScope"
                  :key="index"
                  :value="item.id.toString()"
                  >{{ item.tagName }}</a-select-option
                > -->

                <a-select-option v-for="(item,index) in (roleId==6 || roleId==4) ? $store.getters.getGradeScope : schoolGradeList" :key="index" 
                  :value="(roleId==6 || roleId==4) ? item.id.toString(): item.gradeTagId.toString()">
                  {{ (roleId==6 || roleId==4) ? item.tagName :item.gradeName }}
                </a-select-option>
              </a-select>
              <div v-if="errGradeText && classifyIdValue != 3" class="errGrade">{{ errGradeText }} 不在当前允许的年级范围内</div>
            </a-form-item>

            <!-- 资源类型 平台管理员能改，机构选择平台课能看-->
            <a-form-item
              label="资源类型"
              :labelCol="{ lg: { span: 7 } }"
              :wrapperCol="{ lg: { span: 13 } }"
              v-if="roleId == '6' || (platformCourse && roleId == '4')"
            >
              <a-select
                :disabled="platformCourse"
                placeholder="请选择"
                v-decorator="[
                  'resourceType',
                  { rules: [{ required: true, message: '请选择' }] },
                ]"
              >
                <a-select-option
                  v-for="(item, index) in resourceTypeList"
                  :key="index"
                  :value="item.value.toString()"
                  >{{ item.key }}</a-select-option
                >
              </a-select>
            </a-form-item>

            <!-- Web地址 -->
            <a-form-item
              label="Web地址"
              :labelCol="{ lg: { span: 7 } }"
              v-if="form.getFieldValue('resourceType') == '2'"
              :wrapperCol="{ lg: { span: 13 } }"
            >
              <a-input
                type="text"
                :disabled="platformCourse"
                v-decorator="['webUrl']"
              />
            </a-form-item>

            <!-- 报名人数范围 -->
            <a-form-item
              label="报名人数范围"
              :labelCol="{ lg: { span: 7 } }"
              :wrapperCol="{ lg: { span: 13 } }"
            >
              <a-input-group compact>
                <a-input-number
                  :min="1"
                  :max="1000"
                  :disabled="platformCourse"
                  class="person-scope"
                  placeholder="请输入"
                  @change="lowerLimitChange"
                  v-decorator="[
                    'lowerLimit',
                    { rules: [{ required: true, message: '' }] },
                  ]"
                  :class="{ noUpper: upperFlag }"
                />
                <a-input class="person-gap" placeholder="~" disabled :class="{ noUpper2: upperFlag }"/>
                <a-input-number
                  :min="form.getFieldValue('lowerLimit')? form.getFieldValue('lowerLimit') + 1 : 2"
                  :max="100000"
                  :disabled="platformCourse"
                  class="person-scope max-person"
                  placeholder="请输入"
                  @change="upperLimitChange"
                  v-decorator="[
                    'upperLimit',
                    { rules: [{ required: true, message: '请输入' }] },
                  ]"
                  :class="{ noUpper3: upperFlag }"
                />
              </a-input-group>
              <div class="upper-explain" v-show="upperFlag">请输入</div>
            </a-form-item>
            <!-- 建议教学时长范围 -->
            <a-form-item
              label="建议教学时长范围"
              :labelCol="{ lg: { span: 7 } }"
              :wrapperCol="{ lg: { span: 13 } }"
            >
              <a-select
                style="width: 80px"
                :disabled="platformCourse"
                v-decorator="[
                  'teachingTime_start',
                  { rules: [{ required: true, message: '请选择' }] },
                ]"
              >
                <a-select-option
                  :value="item"
                  v-for="(item, index) in gapTime"
                  :key="index"
                  >{{ item }}</a-select-option
                >
              </a-select>
              <span class="select-desc">分钟</span>
              <span class="select-and">~</span>
              <a-select
                style="width: 80px"
                :disabled="platformCourse"
                v-decorator="[
                  'teachingTime_end',
                  { rules: [{ required: true, message: '请选择' }] },
                ]"
              >
                <a-select-option
                  :value="item"
                  v-for="(item, index) in gapTime"
                  :key="index"
                  >{{ item }}</a-select-option
                >
              </a-select>
              <span class="select-desc">分钟</span>
              <div class="form-desc">建议上限浮动范围不超过30分钟</div>
            </a-form-item>

            <!-- 上课周期 -->
            <a-form-item
              label="上课周期"
              :labelCol="{ lg: { span: 7 } }"
              :wrapperCol="{ lg: { span: 13 } }"
            >
              <a-select
                mode="multiple"
                :disabled="platformCourse"
                placeholder="请选择"
                @change="classWeeks_change()"
                v-decorator="[
                  'classWeeks',
                  { rules: [{ required: true, message: '请选择' }] },
                ]"
              >
                <a-select-option
                  v-for="(item, index) in weekList"
                  :key="index"
                  :value="item.code.toString()"
                  >{{ item.value }}</a-select-option
                >
              </a-select>
            </a-form-item>

            <!-- 场地备注 -->
            <a-form-item
              label="场地备注"
              :labelCol="{ lg: { span: 7 } }"
              :wrapperCol="{ lg: { span: 13 } }"
            >
              <a-input
                type="textarea"
                :disabled="platformCourse"
                v-decorator="[
                  'placeRemark',
                  {
                    rules: [
                      {
                        pattern: /^.{0,400}$/,
                        message: '请输入长度为1~400位的场地备注',
                      },
                    ],
                    validateTrigger: 'change',
                  },
                ]"
              />
              <div class="shelter"></div>
            </a-form-item>

            <!-- 课程级别 -->
            <a-form-item
              label="课程级别"
              :labelCol="{ lg: { span: 7 } }"
              :wrapperCol="{ lg: { span: 13 } }"
            >
              <a-select
                :disabled="platformCourse"
                placeholder="请选择"
                v-decorator="[
                  'courseLevel',
                  { rules: [{ required: true, message: '请选择' }] },
                ]"
              >
                <a-select-option
                  v-for="(item, index) in courseLevelList"
                  :key="index"
                  :value="item.code.toString()"
                  >{{ item.value }}</a-select-option
                >
              </a-select>
            </a-form-item>

            <!-- 课时数 -->
            <a-form-item
              label="课时数"
              :labelCol="{ lg: { span: 7 } }"
              :wrapperCol="{ lg: { span: 13 } }"
            >
              <a-input-number
                :min="1"
                :max="1000"
                :disabled="platformCourse"
                style="width: 100%"
                @change="handleClassHoursChange"
                v-decorator="[
                  'classHours',
                  {
                    rules: [
                      {
                        required: true,
                        pattern: /^\d{1,1000}$/,
                        message: '请输入正整数',
                      },
                    ],
                    validateTrigger: 'change',
                  },
                ]"
              />
              <!-- 课时提示 -->
              <p class="course-info">填写开班时一学期安排的课时数</p>
              <div v-if="classifyIdValue == 1 || classifyIdValue == 2">
                <p class="course-info" v-show="classCycle">
                  ⚠ 如果上课周期为每周{{ classFrequency }}节，当前课时预计持续时间为{{ classCycle }}周<span>
                  (约为{{ Math.round(classCycle / 4.25) }}个月)</span>，
                  <span v-show="Math.round(classCycle / 4.25) >= 5">超出</span><span v-show="Math.round(classCycle / 4.25) <= 2">不足</span>1学期时间范围
                </p>
              </div>
            </a-form-item>

            <!-- 课时总价 -->
            <div :class="['',(roleId ==3?(fixPrice && classifyIdValue ==2):roleId ==4?(fixPrice && classifyIdValue ==1):false)?'tips':'']">
              <!-- institutionSetting.institutionCourseParentCoursePrice == '1'  -->
            <a-form-item
              :label="roleId == 4 && sourceType == 2? '家长报名每学期课时总价':'课时总价'"
              :labelCol="{ lg: { span: 7 } }"
              :wrapperCol="{ lg: { span: 13 } }"
            >
            <!-- (this.roleId ==3?(fixPrice && classifyIdValue ==2):this.roleId ==4?(fixPrice && classifyIdValue ==1):false) -->
              <a-input-number
                :min="0"
                :max="10000"
                style="width: 100%"
                @focus = "coursePriceChangeFocus"
                @change="coursePriceChange"
                :disabled="platformCourse || (roleId ==3?(fixPrice && classifyIdValue ==2):roleId ==4?(fixPrice && classifyIdValue ==1 || institutionSetting.institutionCourseParentCoursePrice == '0'):false)"
                v-decorator="[
                  'coursePrice',
                  {
                    rules: [
                      { required: (roleId ==3?(fixPrice && classifyIdValue ==2):roleId ==4?(fixPrice && classifyIdValue ==1):false)? false:true, message: '请输入'},
                      {
                        pattern: /^(\d+)(.\d{0,2})?$/,
                        message: '最多两位小数',
                      },
                    ],
                    validateTrigger: 'change',
                  },
                ]"
              />
              <!-- <span v-if="(roleId ==3?(fixPrice && classifyIdValue ==2):roleId ==4?(fixPrice && classifyIdValue ==1):false)">注：不可自主定价</span> -->
              <div v-if="roleId == 4 && sourceType == 2">
                <p class="course-info">
                  {{ institutionSetting.institutionCourseParentCoursePrice == '1'? '填写家长报名班级时需支付的金额' : '⚠ 教育局设定为不向家长收费' }}
                </p>
              </div>
            </a-form-item>
          </div>
            <!-- 教育局采购价 机构\管理员 -->
            <a-form-item
              v-if="(roleId == 4) && institutionSetting.institutionCourseBureauPurchase == '1'"
              label="教育局采购每学期采购价"
              :labelCol="{ lg: { span: 7 } }"
              :wrapperCol="{ lg: { span: 13 } }"
              >
              <a-input-number
                :min="0"
                :max="100000"
                style="width: 100%"
                v-decorator="[
                  'purchasePrice',
                  {
                    rules: [
                      { required: true, message: '请输入'},
                      {
                        pattern: /^(\d+)(.\d{0,2})?$/,
                        message: '最多两位小数',
                      },
                    ],
                    validateTrigger: 'change',
                  },
                ]"
              />
            </a-form-item>
            <!-- 教育局采购说明 -->
            <a-form-item
             v-if="(roleId == 4) && institutionSetting.institutionCourseBureauPurchase == '1'"
             label="采购价格说明"
             :labelCol="{ lg: { span: 7 } }"
             :wrapperCol="{ lg: { span: 13 } }"
             >
               <a-input style="max-height: 160px;min-height: 80px;padding: 9px 11px;"
                 type="textarea"
                 :maxLength="200"
                 v-decorator="[
                   'purchaseComment',
                   {
                     rules: [
                       { required: true, message: '请输入' },
                     ],
                     validateTrigger: 'change',
                   },
                 ]"
               />
            </a-form-item>
            
            <!-- 服务学校 只有机构才有服务学校 -->
            <a-form-item
              label="服务学校"
              :labelCol="{ lg: { span: 7 } }"
              :wrapperCol="{ lg: { span: 13 } }"
              v-if="roleId == '4'"
            >
              <div class="flex-items">
                <a-select
                  style="flex: 1"
                  showSearch
                  :mode="whiteListFlag ? 'multiple' : 'default'"
                  placeholder="请选择"
                  :filterOption="false"
                  @search="searchServiceSchool"
                  :notFoundContent="
                    searchlLoading_serviceSchool ? undefined : '没有查询结果'
                  "
                  v-decorator="[
                    'serviceSchoolId',
                    { rules: [{ required: true, message: '请选择' }] },
                  ]"
                >
                  <a-spin
                    v-if="searchlLoading_serviceSchool"
                    slot="notFoundContent"
                    size="small"
                  />
                  <a-select-option
                    v-for="(item, index) in schoolServiceList"
                    :value="item.id"
                    :key="index"
                    >{{ item.schoolName }}</a-select-option
                  >
                </a-select>
                <a class="select-alink" @click="allServiceSchool()" v-if="whiteListFlag">全部</a>
                <a class="select-alink" @click="clearServiceSchool()">取消全部</a>
              </div>
            </a-form-item>

            <!-- 是否包含教材/教具 -->
            <a-form-item
              label="是否包含教材/教具"
              :labelCol="{ lg: { span: 7 } }"
              :wrapperCol="{ lg: { span: 13 } }"
            >
              <a-select
                placeholder="请选择"
                :disabled="platformCourse"
                @change="hasTextbookChange"
                v-decorator="[
                  'hasTextbook',
                  { rules: [{ required: true, message: '请选择' }] },
                ]"
              >
                <a-select-option
                  v-for="(item, index) in hasTextbookOptions"
                  :key="index"
                  :value="item.value.toString()"
                  >{{ item.code }}</a-select-option
                >
              </a-select>
            </a-form-item>

            <!-- 包含，显示后面选项 -->
            <template v-if="this.hasTextbook == '1'">
              <a-form-item
                label="教材/教具名称"
                :labelCol="{ lg: { span: 7 } }"
                :wrapperCol="{ lg: { span: 13 } }"
              >
                <a-input
                  type="textarea"
                  :disabled="platformCourse"
                  v-decorator="[
                    'textbook',
                    {
                      rules: [
                        {
                          required: true,
                          pattern: /^.{2,12}$/,
                          message: '请输入长度为2~12位的教材名称',
                        },
                      ],
                      validateTrigger: 'change',
                    },
                  ]"
                />
                <div class="shelter"></div>
              </a-form-item>

              <!-- 教材价格 -->
              <div :class="['',(this.roleId ==3?(fixPrice && classifyIdValue ==2):this.roleId ==4?(fixPrice && classifyIdValue ==1):false)?'tips':'']">
              <a-form-item
                label="教材/教具价格"
                :labelCol="{ lg: { span: 7 } }"
                :wrapperCol="{ lg: { span: 13 } }"
              >
                <a-input-number
                  :min="0"
                  :max="10000"
                  style="width: 100%"
                  :disabled="platformCourse || (this.roleId ==3?(fixPrice && classifyIdValue ==2):this.roleId ==4?(fixPrice && classifyIdValue ==1):false)"
                  v-decorator="[
                    'textbookPrice',
                    {
                      rules: [
                        { required: (this.roleId ==3?(fixPrice && classifyIdValue ==2):this.roleId ==4?(fixPrice && classifyIdValue ==1):false)? false:true, message: '请输入' },
                        {
                          pattern: /^(\d+)(.\d{0,2})?$/,
                          message: '最多两位小数',
                        },
                      ],
                      validateTrigger: 'change',
                    },
                  ]"
                />
              <span v-if="(this.roleId ==3?(fixPrice && classifyIdValue ==2):this.roleId ==4?(fixPrice && classifyIdValue ==1):false)">注：不可自主定价</span>  
              </a-form-item>
            </div>

              <!-- 是否必须购买 -->
              <a-form-item
                label="是否必须购买"
                :labelCol="{ lg: { span: 7 } }"
                :wrapperCol="{ lg: { span: 13 } }"
              >
                <a-radio-group
                  :options="shoppingOptions"
                  :disabled="platformCourse"
                  v-decorator="[
                    'textbookRequired',
                    { rules: [{ required: true, message: '请选择' }] },
                  ]"
                />
              </a-form-item>
            </template>
          </a-form>

          <div class="step-2 step-box" v-show="current == 1" ref="step2Ref">
            <div
              class="lesson-item"
              v-for="(item, index) in courseLesson"
              :key="index"
              ref="lessonItemRef"
            >
              <div class="lesson-title">
                课节{{ index + 1 }}/{{ classHourCount }}
              </div>
              <a-form-item
                label="课节标题"
                :labelCol="{ lg: { span: 4 } }"
                :wrapperCol="{ lg: { span: 18 } }"
                :required="courseSetting.title"
              >
                <a-input
                  type="text"
                  :maxLength="120"
                  v-model="courseLesson[index].title"
                  :disabled="platformCourse"
                ></a-input>
              </a-form-item>

              <a-form-item
                label="课节内容"
                :labelCol="{ lg: { span: 4 } }"
                :wrapperCol="{ lg: { span: 18 } }"
              >
                <a-textarea
                  placeholder="请输入"
                  :disabled="platformCourse"
                  style="min-height: 55px;"
                  maxlength="100"
                  v-model="courseLesson[index].content"
                />
              </a-form-item>

              <a-form-item
                label="课节资源"
                :labelCol="{ lg: { span: 4 } }"
                :wrapperCol="{ lg: { span: 20 } }"
              >
                <c-progress
                  name="上传文件"
                  ref="lessonResource1"
                  :isDisabled="platformCourse"
                  :backIndex.sync="index"
                  title="1.授课课件"
                  tips="请上传视频/音频/pdf或者zip格式（ppt需转成pdf）"
                  accept="audio/*,video/*,.zip,.pdf"
                  lesType="1"
                  :videoObj="courseLesson[index].lessonResource"
                  @uploadSuccess="uploadSuccess_attachment"
                  @buttonDisabled="buttonDisabled"
                ></c-progress>

                <c-progress
                  name="上传文件"
                  ref="lessonResource3"
                  :isDisabled="platformCourse"
                  :backIndex.sync="index"
                  title="2.课程视频片段"
                  tips="请上传视频/音频/pdf或者zip格式"
                  accept="audio/*,video/*,.zip,.pdf"
                  lesType="2"
                  :videoObj="courseLesson[index].lessonResource"
                  @uploadSuccess="uploadSuccess_attachment"
                  @buttonDisabled="buttonDisabled"
                ></c-progress>
                <div ref="lessonResourceRef"></div>
                <c-progress
                  name="上传文件"
                  ref="lessonResource2"
                  :isDisabled="platformCourse"
                  :backIndex.sync="index"
                  title="3.教学教案"
                  :isRequired="courseSetting.lessonResource == 3"
                  tips="文档格式/zip格式"
                  accept=".pdf,.doc,.docx,.xls,.xlsx,.pot,.dot,.pps,.ppt,.pptx,.wps,.zip"
                  lesType="3"
                  icon="attachment"
                  :videoObj="courseLesson[index].lessonResource"
                  @uploadSuccess="uploadSuccess_attachment"
                  @buttonDisabled="buttonDisabled"
                ></c-progress>
              </a-form-item>

              <div
                class="delete hover-font-active"
                v-if="!platformCourse && !courseSetting.classHour"
                @click="deletaLesson(index)"
              >
                删除
              </div>
            </div>
            <div class="add" v-if="!platformCourse && form.getFieldValue('classHours') > courseLesson.length && !courseSetting.classHour">
              <a-button type="primary" @click="addCourseLesson"
                >新增课节</a-button
              >
            </div>
          </div>

          <div class="step-3 step-box" v-show="current == 2">
            <c-richtext
              :editorContent.sync="editorContent"
              :disabled="platformCourse"
            ></c-richtext>
          </div>

          <div class="steps-oper">
            <a-button v-if="current > 0" @click="prev"> 上一步 </a-button>
            <a-button
              class="prev"
              v-show="current < steps.length - 1"
              type="primary"
              @click="next"
              style="margin-left: 10px"
            >
              下一步
            </a-button>
            <a-button
              class="submit"
              v-if="current == steps.length - 1"
              type="primary"
              @click="handleSubmit"
            >
              确定
            </a-button>
            <a-modal
              :closable="false"
              :visible="submitVisible"
              :confirm-loading="confirmLoading"
              :width="327"
              :footer="null"
            >
              <div style="text-align: center; margin-bottom: 17px">
                {{ tips1 }}
              </div>
              {{ tips2 }}
              <div style="text-align: center; margin-top: 17px">
                <a-button
                  type="primary"
                  style="margin-right: 18px"
                  @click="submitOk"
                  >确定</a-button
                >
                <a-button @click="submitCancel">取消</a-button>
              </div>
            </a-modal>
          </div>
        </template>
      </div>
    </a-spin>
  </a-modal>
</template>

<script>
import course from '../../api/course'

import CUpload from '../../components/CUpload' // 封面上传

import institution from '../../api/institution'

import school from '../../api/school'

import CRichtext from '../../components/CRichtext' // 课程介绍

import CProgress from '../../components/CProgress'

import weekList from '../../code/weekList'

import bureau from '../../api/bureau'

import user from '../../api/user'

import { analysisAddress } from '../../utils/address'

import Vue from 'vue'
export default {
  name: 'courseFormModal',
  components: {
    CRichtext,
    CUpload,
    CProgress,
  },
  data() {
    return {
      visible: false,
      submitVisible: false,
      confirmLoading: false,
      form: this.$form.createForm(this),
      isAdd: true,
      courseId: '',
      updateData: {},
      courseSetting: {
        classHour: false,
        title: false,
        lessonResource: 2,
      }, // 教育局必填资料设置
      editorContent: '', //编辑器内容
      avatarUrl: '', //头像
      sourceFileList: [], //头像回显
      steps: [
        {
          title: '基本信息',
        },
        {
          title: '课节内容',
        },
        {
          title: '课程介绍',
        },
      ],
      shoppingOptions: [
        { label: '是', value: '1' },
        { label: '否', value: '0' },
      ],
      hasTextbookOptions:[
        {code: '是',value: '1'},
        {code: '否',value: '0'}
      ],
      schoolGradeList:[],
      current: 0,
      sourceType: '', //平台来源
      schoolServiceList: [], //服务学校List
      searchlLoading_serviceSchool: false, //搜索学校loading
      searchLoading_course: false, //搜索课程loading

      roleId: '', //角色ID
      courseLesson: [], //课节内容

      showPlatformSelect: null, //是否显示平台选择
      courseList: [], //选择平台的课
      fromCourseId: '', //如果选择平台的课，需要把平台的ID带进去
      weekList: weekList,
      courseLevelList: [
        { code: '1', value: '初级班' },
        { code: '2', value: '中级班' },
        { code: '3', value: '高级班' },
      ],
      bureauList: [],
      // gapTime: [
      //   30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90, 95, 100, 105, 110, 115, 120, 125, 130,
      //   135, 140, 145, 150, 155, 160, 165, 170, 175, 180,
      // ],
      gapTime: [],
      coursePriceSave:'',  // 如果不能自主定价，并且是不能的课程分类且有值，保存之前的值
      textbookPriceSave:'', // 如果不能自主定价，并且是不能的课程分类且有值，保存之前的值
      fixPrice: false,
      bureauId: '', //当前站点ID
      resourceTypeList: [
        { key: '普通', value: '1' },
        { key: '外部web', value: '2' },
        { key: '双师课堂', value: '3' },
      ],
      hasTextbook: '',
      classifyIdValue: null,
      tips1: '', // 新建或修改课程提示文本
      tips2: '', // 修改课程提示文本
      disabledSpin: false,
      gradeArr:[], //年级
      errGrades:[], //失效的年级
      errGradeText:"", 
      institutionSetting:{} , // 教育局收费设置
      institutionId:null,
      whiteListFlag: false,
      upperFlag: false,
      classFrequency: 0,
      classHourCount:0
    }
  },
  computed: {
    platformCourse() {
      // 课程来源为平台，但是当前用户不是平台
      return this.sourceType == '3' && this.roleId != '6' ? true : false
    },
    classCycle(){
      let cycle
      if (this.classFrequency && this.classHourCount){
        cycle = Math.ceil(this.classHourCount / this.classFrequency)
        if(cycle>= 20 || cycle <= 8){
          return cycle
        }
      }
    }
  },
  methods: {
    getBureauCourseSetting(e){
      let params = this.roleId == 6 ? e : Vue.ls.get('bureauId')
      course.getCourseRequiredSetting(params).then(res=>{
        let v = Number(res.data)
        if(this.roleId == 3) {
          let xnv = v >> 16
          if((xnv & 8) == 8) this.courseSetting.classHour = true
          if((xnv & 4) == 4) this.courseSetting.title = true
          if((xnv & 3) == 3) this.courseSetting.lessonResource = 3
          if((xnv & 3) == 2) this.courseSetting.lessonResource = 2
          if((xnv & 3) == 0) this.courseSetting.lessonResource = 0
        } else {
          if((v & 8) == 8) this.courseSetting.classHour = true
          if((v & 4) == 4) this.courseSetting.title = true
          if((v & 3) == 3) this.courseSetting.lessonResource = 3
          if((v & 3) == 2) this.courseSetting.lessonResource = 2
          if((v & 3) == 0) this.courseSetting.lessonResource = 0
        }
        console.log(v,this.courseSetting,'res')
      })
    },
    lowerLimitChange(e) {
      let temp = this.form.getFieldValue('upperLimit')
      this.upperFlag =  temp === null ? true : false;
    },
    upperLimitChange(e) {
      let temp = this.form.getFieldValue('lowerLimit')
      if(temp === null) return
      this.upperFlag = (e === '' || e === null) ? true : false;
    },
    buttonDisabled(value) {
      this.disabledSpin = value
    },
    hasTextbookChange(value) {
      this.hasTextbook = value
    },

    classifyIdChange(value){
      this.classifyIdValue = value
    },
    handleClassHoursChange(value){
      this.classHourCount = value
    },
    coursePriceChange(value){
    },
    coursePriceChangeFocus(value){
      // console.log(value,'coursePriceChangeFocus')
    },
    //设置全部学校
    allServiceSchool() {
      const tempList = []
      this.schoolServiceList.map((item) => {
        tempList.push(item.id)
      })
      this.form.setFieldsValue({ serviceSchoolId: tempList })
    },

    clearServiceSchool() {
      this.form.setFieldsValue({ serviceSchoolId: [] })
    },

    //获取代理列表
    selectSearchBureau(val = '', id) {
      let req = {
        bureauName: val,
      }
      if (id) {
        req.id = id
      }
      bureau.selectSearchBureau(req).then((res) => {
        this.bureauList = res.data
      })
    },

    //选择我们的课程
    chooseUsCourse() {
      this.sourceType = '2'
      this.showPlatformSelect = false
      setTimeout(() => {
        this.form.setFieldsValue({
          teachingTime_start: 30,
          teachingTime_end: 60,
        })
      }, 100)
    },

    // 下载文件回调
    uploadSuccess_attachment(backIndex) {
      //只有obj存在，新增，反之删除
      const lessonResource1 =
        this.$refs.lessonResource1[backIndex].successUpload_data()
      const lessonResource2 =
        this.$refs.lessonResource2[backIndex].successUpload_data()
      const lessonResource3 =
        this.$refs.lessonResource3[backIndex].successUpload_data()
      this.$set(this.courseLesson[backIndex], 'lessonResource', [
        ...lessonResource1,
        ...lessonResource2,
        ...lessonResource3,
      ])
    },

    classWeeks_change() {
      setTimeout(() => {
        this.form.getFieldValue('classWeeks').sort((a, b) => parseInt(a) - parseInt(b))
        this.classFrequency = this.form.getFieldValue('classWeeks').length
      }, 0)
    },
    //初始化平台
    initShowPlatformSelect() {
      //如果是平台，就直接创建
      if (this.roleId == '6') {
        this.showPlatformSelect = false
      } else {
        this.showPlatformSelect = true
      }
    },

    //删除课节
    deletaLesson(index) {
      this.courseLesson.splice(index, 1)
    },

    //新增课节内容
    addCourseLesson() {
      this.courseLesson.push({
        classPeriodNum: this.courseLesson.length + 1,
        title: '',
        content: '',
      })
      console.log(this.courseLesson)
    },

    //封面上传成功之后回调
    uploadSuccess(url) {
      this.avatarUrl = url
    },

    //下一步
    next() {
      //校验
      if(this.roleId == '4' && this.institutionSetting.institutionCourseParentCoursePrice == '0'){
        this.form.setFieldsValue({coursePrice: 0})
      }
      this.upperFlag = (this.form.getFieldValue('lowerLimit') && this.form.getFieldValue('upperLimit')) ? false : true
      this.form.validateFieldsAndScroll((err, value) => {
        console.log('value校验', value)
        //校验通过
        if (!err) {
          // 课节内容添加必传项
          if (this.current == 0) {
            let arrLength = this.classHourCount
            if (arrLength > 20 && !this.courseSetting.classHour) arrLength = 20
            if(this.courseLesson.length < arrLength) {
              for (let index = 0; index < arrLength; index++) {
                this.courseLesson.push({
                  classPeriodNum: this.courseLesson.length + 1,
                  title: '',
                  content: '',
                })
                if(this.courseLesson.length == arrLength) {
                  this.current++
                  this.$nextTick(()=>{
                    this.$refs.step2Ref.scrollIntoView({
                      behavior: 'smooth', 
                      block: 'start'
                    });
                  })
                  return
                }
              }
            } else if (this.courseLesson.length > arrLength) {
              this.courseLesson.splice(arrLength)
            }
            return this.current++
          }
          // 判断课节内容页
          if (this.current == 1) {
            // 必填标题时校验
            if (this.courseSetting.title) {
              for (let i = 0; i < this.courseLesson.length; i++ ){
                if (!this.courseLesson[i].title) {
                  this.$message.error(`请填写第${i + 1}节课标题`)
                  this.$nextTick(()=>{
                    this.$refs.lessonItemRef[i].scrollIntoView({
                      behavior: 'smooth',
                      block: 'start'
                    });
                  })
                  return
                }
              }
            }
            // 校验教案个数
            if (this.courseSetting.lessonResource){
              let resourceCount = this.courseLesson.filter(item=>item.lessonResource && item.lessonResource.length).length
              let min = Math.min(3,this.classHourCount)
              if(this.courseLesson.length < min) {
                this.$message.error(`请至少添加${min}节课节`)
                return
              }
              if (this.courseSetting.lessonResource == 2 && resourceCount < min) {
                this.$message.error(`请至少上传${min}节课教学教案`)
                return
              }
              if (this.courseSetting.lessonResource == 3 && resourceCount !== this.courseLesson.length) {
                for (let i = 0; i < this.courseLesson.length; i++ ){
                  if (!(this.courseLesson[i].lessonResource && this.courseLesson[i].lessonResource.length)) {
                    this.$message.error(`请上传第${i + 1}节课教学教案`)
                    this.$nextTick(()=>{
                      this.$refs.lessonResourceRef[i].scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                      });
                    })
                    return
                  }
                }
                return
              }
            }
            // 校验课节完整
            let checkCourseCount = this.checkCourseLesson()
            if(!checkCourseCount && !this.courseSetting.title && this.courseSetting.lessonResource != 0) return
            if(checkCourseCount !== this.classHourCount){
              let _this = this
              this.$confirm({
                title: '确定要修改课程?',
                content: '提交的课程大纲'+ checkCourseCount + '节与课时数'+ this.classHourCount +'不相符，是否确认提交',
                onOk() {
                  _this.current++
                },
                onCancel() {
                  return
                },
              });
            } else {
              this.current++
            }
          }
        }
      })
    },
    prev() {
      this.current--
    },
    // 校验课节完整
    checkCourseLesson(){
      let count = 0
      // 检验中间是否有空的item
      let lastIndex = -1
      let firstEmptyIndex = 0
      let tempArr = [...this.courseLesson]
      console.log(tempArr,'arr')
      tempArr.reverse().forEach((item, index)=>{
        if(lastIndex == -1){
          if(item.title || item.content || (item.lessonResource && item.lessonResource.length)){
            lastIndex = index
          }
        }
        if(index > lastIndex && lastIndex > -1 && !item.title && !item.content && !(item.lessonResource && item.lessonResource.length)){
          firstEmptyIndex = this.courseLesson.length - index
          return
        }
      })
      if(firstEmptyIndex){
        this.$message.error(`第${firstEmptyIndex}课节未填写`)
        this.$nextTick(()=>{
          this.$refs.lessonItemRef[firstEmptyIndex - 1].scrollIntoView({
            behavior: 'smooth', 
            block: 'start' 
          });
        })
        return false
      }
      this.courseLesson.forEach(item=>{
        if(item.title || item.content || item.lessonResource && item.lessonResource.length){
          count++
        }
      })
      return count
    },

    //搜索服务学校
    searchServiceSchool(val = '') {
      this.searchlLoading_serviceSchool = true
      school.selectSchoolOfBureau({ schoolName: val }).then((res) => {
        this.searchlLoading_serviceSchool = false
        this.schoolServiceList = res.data
      })
    },

    //初始化，显示
    init(type, receiveParams) {
      console.log('receiveParams',receiveParams)

      // console.log(params,'formform')
      for (var i = 30; i <= 720; i += 5) {
        this.gapTime.push(i)
      }
      // 获取服务学校
      this.searchServiceSchool()
      
      this.visible = true
      this.current = 0
      this.courseLesson = []
      this.fromCourseId = ''
      this.avatarUrl = ''
      this.isAdd = type === 'update' ? false : true
      if(this.isAdd = type === 'update' ? false : true){
        this.classifyIdValue = ''
      }
      this.selectSearchBureau()
      this.hasTextbook = ''
      course.modifyCourse(type).then((res) => {
        this.tips1 = res.data.tips1
        this.tips2 = res.data.tips2
      })
      if (!this.isAdd || type == 'copy') {
        const params = JSON.parse(JSON.stringify(receiveParams))
        // console.log(params,'paramsparams',this.roleId,this.whiteListFlag,this.institutionSetting)
        //初始化form表单数据
        if (params) {
          this.updateData = params
          let formData = {}
          //修改不用选择平台
          this.showPlatformSelect = false
          //如果是平台管理员
          if (this.roleId == 6) {
            formData.bureauId = params.bureauId
            this.bureauId = params.bureauId
            this.getBureauCourseSetting(params.bureauId)
          }
          formData.courseName = params.courseName
          formData.classifyId = params.classifyId
          this.classifyIdValue = params.classifyId

          if(this.roleId == 3 &&!this.isAdd && this.classifyIdValue==2){
            this.coursePriceSave= params.coursePrice / 100
            this.textbookPriceSave= params.textbookPrice / 100
          }
          if(this.roleId == 4 && !this.isAdd && this.classifyIdValue==1){
            this.coursePriceSave= params.coursePrice / 100
            this.textbookPriceSave= params.textbookPrice / 100
          }
          formData.resourceType = params.resourceType.toString()
          formData.webUrl = params.webUrl
          if (params.cateFirstId && params.classifyId == 3){
            formData.cateList = [params.cateFirstId]
          }
          if (params.cateFirstId && params.cateSecondId) {
            formData.cateList = [params.cateFirstId, params.cateSecondId]
            if (params.cateThirdId) formData.cateList.push(params.cateThirdId)
          }
          if(this.roleId == 4 && this.institutionSetting.institutionCourseOfferringLimit == '1' && !this.whiteListFlag && params.serviceSchoolIdList.length > 1 ){
            params.serviceSchoolIdList = []
          }
          // 处理年级数据
          if(this.roleId == 6 || this.roleId == 4){
            formData.purchasePrice = params.purchasePrice? params.purchasePrice / 100 : 0
            formData.purchaseComment = params.purchaseComment? params.purchaseComment: ''
            formData.gradeScope = params.gradeScope
            ? params.gradeScope.split(',')
            : []
          } else {
            let tempGrade = []
            formData.gradeScope = []
            tempGrade = params.gradeScope.split(',')
            tempGrade.forEach(item =>{
              if (this.gradeArr.includes(parseInt(item))){
                formData.gradeScope.push(item)
              }else {
                this.errGrades.push(parseInt(item))
              }
            })
            if(this.errGrades){
              let temp = []
              this.$store.getters.getGradeScope.forEach(item =>{
                if(this.errGrades.includes(item.id)){
                  temp.push(item.tagName)
                }
              })
              this.errGradeText = temp.join(',')
            }
          }
          formData.lowerLimit = params.lowerLimit
          formData.upperLimit = params.upperLimit
          formData.classWeeks = params.classWeeks
            ? params.classWeeks
                .split(',')
                .sort((a, b) => parseInt(a) - parseInt(b))
            : []
          this.classFrequency = formData.classWeeks.length
          formData.placeRemark = params.placeRemark
          formData.courseLevel = params.courseLevel
            ? params.courseLevel.toString()
            : ''

          //建议教学时间
          const teachingTimeList = params.teachingTime
            ? params.teachingTime.split('-')
            : []
          if (teachingTimeList.length == 2) {
            formData.teachingTime_start = teachingTimeList[0]
            formData.teachingTime_end = teachingTimeList[1]
          }
          formData.institutionId = params.institutionId
          formData.schoolId = params.schoolId
          formData.classHours = parseInt(params.classHours)
          this.classHourCount = formData.classHours
          formData.totalPrice = params.totalPrice / 100
          formData.coursePrice = params.coursePrice / 100
          if (this.roleId == 4 && this.institutionSetting.institutionCourseParentCoursePrice == '0') formData.coursePrice = 0
          this.editorContent = (!params.intro ? '' : params.intro)
          formData.serviceSchoolId = params.serviceSchoolIdList
          formData.textbook = params.textbook
          // formData.hasTextbook =
          //   params.hasTextbook || params.hasTextbook == 0
          //     ? params.hasTextbook.toString()
          //     : null
          formData.hasTextbook = params.hasTextbook.toString()
          this.hasTextbook = formData.hasTextbook
          formData.textbookPrice = params.textbookPrice / 100
          formData.textbookRequired =
            params.textbookRequired || params.textbookRequired == 0
              ? params.textbookRequired.toString()
              : null
          formData.lessonResource = params.lessonResource
          //课节内容
          this.courseLesson = params.courseLesson ? params.courseLesson : []
          this.courseLesson.forEach((v, i) => {
            v.classPeriodNum = i + 1
          })
          //记录当前课程的ID
          this.courseId = params.id
          this.sourceType = params.sourceType
          this.fromCourseId = params.fromCourseId
          this.sourceFileList = [params.coverUrl]
          this.serviceSchoolBack(params)
          
          this.$nextTick(()=>{
            this.setValue(formData)
            //如果包含教材，在set一次，因为教材的显示需要hasTextbook字段
            if(formData.hasTextbook == 1){
              this.$nextTick(()=>{
                this.form.setFieldsValue({
                  hasTextbook: formData.hasTextbook,
                  textbook: formData.textbook,
                  textbookPrice: formData.textbookPrice,
                  textbookRequired: formData.textbookRequired,
                })
              })
            }
          })
        }
      } else {
        this.sourceFileList = []
        this.editorContent = ''
        this.bureauId = ''
        this.initShowPlatformSelect()
        this.form.resetFields()
        this.initSourceType()
        this.$nextTick(()=>{
          this.form.setFieldsValue({
            teachingTime_start: 30,
            teachingTime_end: 60,
          })
          if(this.roleId == 6) {
            this.form.setFieldsValue({ classifyId : 1 })
          }
        })
      }
      
      let teaBureauSetting = Vue.ls.get('teaBureauSetting')
    for(let i in teaBureauSetting){
      if(teaBureauSetting[i].settingKey == 'course_classify1_price_confirm_by_institution' && this.roleId ==4 && teaBureauSetting[i].settingValue == '0'){
        this.fixPrice = true
      }else if(teaBureauSetting[i].settingKey == 'course_classify1_price_confirm_by_institution' && this.roleId ==4 && teaBureauSetting[i].settingValue == '1') {
        this.fixPrice = false
      }



      if(teaBureauSetting[i].settingKey == 'course_classify2_price_confirm_by_school' && this.roleId == 3 && teaBureauSetting[i].settingValue == '0'){
        this.fixPrice = true
      }
      else if(teaBureauSetting[i].settingKey == 'course_classify2_price_confirm_by_school' && this.roleId == 3 && teaBureauSetting[i].settingValue == '1'){
        this.fixPrice = false
      }
    }
    },

    //服务公校回显
    serviceSchoolBack(params) {
      if (!params.serviceSchoolIdList) return
      for (let i = 0; i < params.serviceSchoolIdList.length; i++) {
        let hasId = false
        this.schoolServiceList.map((item) => {
          if (item.id == params.serviceSchoolIdList[i]) {
            hasId = true
          }
        })
        if (!hasId) {
          this.schoolServiceList.push({
            id: params.serviceSchoolIdList[i],
            schoolName: params.serviceSchoolNameList[i],
          })
        }
      }
    },
    setValue(formData){
        this.form.setFieldsValue({
          bureauId: formData.bureauId,
          courseName: formData.courseName,
          classifyId: formData.classifyId,
          cateList: formData.cateList,
          gradeScope: formData.gradeScope,
          lowerLimit: formData.lowerLimit,
          upperLimit: formData.upperLimit,
          classWeeks: formData.classWeeks,
          placeRemark: formData.placeRemark,
          courseLevel: formData.courseLevel,
          teachingTime_start: formData.teachingTime_start,
          teachingTime_end: formData.teachingTime_end,
          classHours: formData.classHours,
          coursePrice: formData.coursePrice,
          resourceType:formData.resourceType,
          hasTextbook: formData.hasTextbook,
          lessonResource: formData.lessonResource,
          purchasePrice: formData.purchasePrice ? formData.purchasePrice : null,
          purchaseComment: formData.purchaseComment ? formData.purchaseComment : null,
          serviceSchoolId: (this.roleId == '4' && formData.serviceSchoolId && formData.serviceSchoolId.length) ? formData.serviceSchoolId : null,
        })
        this.$nextTick(()=>{
          this.form.setFieldsValue({
            webUrl: formData.webUrl,
          })
        })
      },
    //隐藏
    handleCancel() {
      this.visible = false
      this.gapTime = []
      this.errGrades=[]
      this.errGradeText=''
      // console.log('this.form', this.form)
      this.$emit('closeForm')
      // this.form = {}
      this.courseId = ''
      this.updateData = {}
      this.editorContent = '' //编辑器内容
      this.avatarUrl = '' //头像
      this.sourceFileList = [] //头像回显
      this.current = 0
      this.sourceType = '' //平台来源
      this.schoolServiceList = [] //服务学校List
      this.searchlLoading_serviceSchool = false //搜索学校loading
      this.searchLoading_course = false //搜索课程loading
      // this.roleId = '' //角色ID
      this.courseLesson = [] //课节内容
      this.showPlatformSelect = null //是否显示平台选择
      this.courseList = [] //选择平台的课
      this.fromCourseId = '' //如果选择平台的课，需要把平台的ID带进去
      this.bureauList = []
      this.gapTime = []
      this.bureauId = '' //当前站点ID
      this.hasTextbook = ''
      this.tips1 = '' // 新建或修改课程提示文本
      this.tips2 = '' // 修改课程提示文本
      this.disabledSpin = false
      this.upperFlag = false
      this.classFrequency = 0,
      this.classHourCount = 0
    },

    //提交表单
    handleSubmit() {
      this.submitVisible = true
    },

    // 提交表单
    submitOk(e) {
      console.log('保存')
      e.preventDefault()
      this.gapTime = []
      this.form.validateFields((err, value) => {
        if(this.roleId =='3' && this.classifyIdValue == "2" && this.fixPrice == true){
          value.coursePrice = ''
          value.textbookPrice = ''
        }
        if(this.roleId =='4' && this.classifyIdValue == "1" && this.fixPrice == true){
          value.coursePrice = ''
          value.textbookPrice = ''
        }
        //校验通过
        if (!err) {
          //处理上课周期
          if (value.classWeeks && value.classWeeks.length > 0) {
            value.classWeeks = value.classWeeks.join()
          }

          //处理年级范围
          if (value.gradeScope && value.gradeScope.length > 0) {
            value.gradeScope = value.gradeScope.join()
          }

          //总价格
          value.totalPrice = value.textbookPrice
            ? utils.common.accAdd(value.coursePrice, value.textbookPrice)
            : value.coursePrice

          //服务学校
          if (value.serviceSchoolId && value.serviceSchoolId.length > 0) {
            value.serviceSchoolId = value.serviceSchoolId.join()
          }
          //建议教学时间
          value.teachingTime =
            value.teachingTime_start + '-' + value.teachingTime_end
          //课程介绍
          value.intro = this.editorContent
          //头像
          value.coverUrl = this.avatarUrl || this.sourceFileList[0]
          //平台类型
          value.sourceType = this.sourceType
          //如果选择的是平台课程，对应的ID
          value.fromCourseId = this.fromCourseId
          //课程类目
          value.cateFirstId = value.cateList[0]
          value.cateSecondId = value.cateList[1]
          value.cateThirdId = value.cateList[2]
          delete value.cateList
          // 教育局采购价
          if (value.purchasePrice){
            value.purchasePrice = value.purchasePrice * 100
          }
          //课节内容
          if (this.courseLesson && this.courseLesson.length > 0) {
            for (
              let i = 0, isDelete = false;
              i < this.courseLesson.length;
              i = isDelete ? i : i + 1
            ) {
              //如果课程里面什么都没有，删除当前项
              if (
                !this.courseLesson[i].title &&
                !this.courseLesson[i].content &&
                !(this.courseLesson[i].lessonResource && this.courseLesson[i].lessonResource.length)
              ) {
                this.courseLesson.splice(i, 1)
                isDelete = true
              } else {
                //删除课节里面的时间（后台需要）
                delete this.courseLesson[i].gmtCreate
                delete this.courseLesson[i].gmtModified
                isDelete = false
              }
            }
            value.courseLesson = JSON.stringify(this.courseLesson)
          }
          if (value.intro && (value.intro.length > 30000)) {
            this.$message.error('课程介绍内容长度' + value.intro.length + '，请删减内容到长度30000以内')
          } else if (this.isAdd) {
            this.addCourse(value)
          } else {
            this.updateCourse(value)
          }
          this.submitVisible = false
        } else {
          console.log('异常的内容是：', err)
        }
      })
    },

    // 关闭是否提交提示框
    submitCancel() {
      this.submitVisible = false
    },

    //新增课程
    addCourse(value) {
      course.addCourse(value).then((res) => {
        this.$message.success('新增成功')
        this.handleCancel()
        this.$emit('addCourse', res.data)
      }).catch((err)=>{
        console.log(err,'err')
        if(err.code == 2168 || err.code == 2169){
        // this.$error({title:'请关闭新建课程窗口，刷新页面后重试'})
        user.init().then((res) => {
            console.log('res-----------', res)
            //码表拼接
            Vue.ls.set('teaBureauSetting',res.teaBureauSetting)
          })
        }
      })
    },

    //修改课程
    updateCourse(value) {
      course.updateCourse(this.courseId, value).then((res) => {
        this.$message.success('修改成功')
        Object.assign(this.updateData, value)
        this.$emit('updateCourse', res.data)
        this.handleCancel()
      }).catch((err)=>{
        console.log(err,'errerrerrerr')
        // this.$error({title:'请关闭修改信息窗口，刷新页面后重试'})
        if(err.code == 2168 || err.code == 2169){
          this.$message.
        user.init().then((res) => {
            console.log('res-----------', res)
            //码表拼接
            Vue.ls.set('teaBureauSetting',res.teaBureauSetting)
            console.log(Vue.ls.get('teaBureauSetting'),'res-----------')
          })
        }
      })
    },

    //平台课程列表
    searchCourse(val = '') {
      this.searchLoading_course = true
      course.selectSearch({ courseName: val }).then((res) => {
        this.searchLoading_course = false
        this.courseList = res.data
      })
    },

    //选择一个课程
    courseChange(id) {
      course.getCourseById(id).then((res) => {
        let params = res.data
        let formData = {}
        //如果是平台管理员
        if (this.roleId == 6) {
          formData.bureauId = params.bureauId
          this.bureauId = params.bureauId
        }
        formData.courseName = params.courseName
        formData.classifyId = params.classifyId
        formData.resourceType = params.resourceType.toString()
        formData.webUrl = params.webUrl
        if (params.cateFirstId && params.cateSecondId) {
          formData.cateList = [params.cateFirstId, params.cateSecondId]
          if (params.cateThirdId) formData.cateList.push(params.cateThirdId)
        }
        formData.gradeScope = params.gradeScope
          ? params.gradeScope.split(',')
          : []
        formData.lowerLimit = params.lowerLimit
        formData.upperLimit = params.upperLimit
        formData.classWeeks = params.classWeeks
          ? params.classWeeks
              .split(',')
              .sort((a, b) => parseInt(a) - parseInt(b))
          : []
        formData.placeRemark = params.placeRemark
        formData.courseLevel = params.courseLevel
          ? params.courseLevel.toString()
          : ''
        //建议教学时间
        const teachingTimeList = params.teachingTime
          ? params.teachingTime.split('-')
          : []
        if (teachingTimeList.length == 2) {
          formData.teachingTime_start = teachingTimeList[0]
          formData.teachingTime_end = teachingTimeList[1]
        }
        formData.institutionId = params.institutionId
        formData.schoolId = params.schoolId
        formData.classHours = parseInt(params.classHours)
        formData.totalPrice = params.totalPrice / 100
        formData.coursePrice = params.coursePrice / 100
        this.editorContent = params.intro
        this.sourceFileList = [params.coverUrl]
        this.courseLesson = params.courseLesson ? params.courseLesson : []
        this.classHourCount = formData.classHours
        this.sourceType = params.sourceType
        this.fromCourseId = params.id
        formData.textbook = params.textbook
        formData.hasTextbook =
          params.hasTextbook || params.hasTextbook == 0
            ? params.hasTextbook.toString()
            : null
        this.hasTextbook = formData.hasTextbook
        formData.textbookPrice = params.textbookPrice / 100
        formData.textbookRequired =
          params.textbookRequired || params.textbookRequired == 0
            ? params.textbookRequired.toString()
            : null
        formData.lessonResource = params.lessonResource
        setTimeout(() => {
          this.form.setFieldsValue(formData)
          //如果包含教材，在set一次，因为教材的显示需要hasTextbook字段
          setTimeout(() => {
            this.form.setFieldsValue(formData)
          }, 100)
        }, 100)
      })
    },

    //初始化平台类型
    initSourceType() {
      this.$store.dispatch('getUserInfo').then((res) => {
        this.institutionId = res.id
        this.roleId = res.accRole.id
        //课程来源
        switch (this.roleId.toString()) {
          case '6':
            this.sourceType = '3'
            break //平台
          case '3':
            this.sourceType = '1'
            break //课程方
          case '4':
            this.sourceType = '2'
            break //机构
        }
        this.initShowPlatformSelect()
        // 机构设置和白名单
        if(this.roleId == 4 || this.roleId == 6) {
          this.getInstitutionSetting(res.id)
        }
        // 如果不是管理员则直接获取平台设置
        if (this.roleId != 6) {
          this.getBureauCourseSetting()
        }
      })
    },
    // 获取机构设置
    getInstitutionSetting(id) {
      institution.getInstitutionSetting().then((res) => {
        this.institutionSetting = res.data
        if(res.data.institutionCourseOfferringLimit == '0') {
          this.whiteListFlag = true
        } else {
          if (res.data.institutionIds && res.data.institutionIds.length){
            this.whiteListFlag = res.data.institutionIds.includes(id) ? true : false
          }
        }
        // console.log(res.data.institutionCourseOfferringLimit,this.whiteListFlag,'白名单')
      })
    },
  },
  activated(){
  },
  created() {
    this.gradeArr= Vue.ls.get('schoolGrade').map(item=>{
      return item.gradeTagId
    })
    //加载初始化码表
    this.searchServiceSchool()
    this.searchCourse()
    this.initSourceType()
    user.init().then((res) => {
      //码表拼接
      Vue.ls.set('teaBureauSetting',res.teaBureauSetting)
    })
    this.schoolGradeList = Vue.ls.get('schoolGrade')
  },
}
</script>
<style lang="scss" scoped>
@import 'src/config/var';
.course-form {
  height: calc(100vh - 240px);
  overflow-y: auto;
  overflow-x: hidden;
}
.step-box {
  height: calc(100% - 64px);
  overflow:auto
}
.step-1 {
  padding-top: 16px;
}
.step-3 {
  padding: 20px 10px;
}
.steps-oper {
  text-align: right;
  padding: 0px 10px;
  .submit {
    margin-left: 10px;
  }
  .prev {
    margin-right: 10px;
  }
}
.step-2 {
  margin: 0 atuo;
  text-align: center;
  .add {
    padding: 18px 50px 38px;
    text-align: right;
  }
}
.lesson-item {
  border-bottom: 1px solid $border-color;
  width: 85%;
  display: inline-block;
  padding: 10px 0px;
  margin: 10px 0px;
  position: relative;
  .lesson-title{
    position: absolute;
    left: -55px;
    top: 20px;
    font-weight: bold;
  }
  .delete {
    cursor: pointer;
    color: $normal-color-dark;
    position: absolute;
    right: 0px;
    top: 27px;
    transform: translateY(-50%);
  }
}
.cousre-type-select {
  text-align: center;
  padding: 50px 0px 100px;
  .tab {
    display: inline-block;
    border: 1px solid $border-color;
    border-radius: 10px;
    width: 170px;
    height: 150px;
    text-align: center;
    cursor: pointer;
    margin-right: 50px;
    .title {
      font-size: 24px;
      color: $normal-color;
      margin-top: 44px;
    }
    .desc {
      margin-top: 8px;
      font-size: 12px;
      color: $normal-color-dark;
    }
  }
}
.person-scope {
  width: 100px;
  text-align: center;
  display: inline-block;
}
.max-person {
  border-left: none;
}
.person-gap {
  width: 32px;
  height: 32px !important;
  border-left: 0;
  pointer-events: none;
  background: #fff;
}
.select-desc {
  display: inline-block;
  margin-left: 6px;
}
.select-and {
  display: inline-block;
  margin: 0px 6px;
}
.form-desc {
  color: $normal-color-dark;
  font-size: 14px;
}
.all-server-school {
  position: absolute;
  top: -12px;
  right: -38px;
  text-decoration: underline;
}
.flex-items {
  display: flex;
  align-items: flex-end;
  align-items: center;
  .select-alink {
    margin-left: 10px;
    display: inline-block;
  }
}

.course-form ::v-deep .ant-input-number-disabled{
   border-color:#d9d9d9;
 }
.tips ::v-deep .ant-form-explain{
  display: none;
} 

.course-form ::v-deep .ant-input {
    box-shadow: 0 0 0 1000px #fff inset;
    background-color: #fff;
}
.course-form ::v-deep .ant-input::selection {
    box-shadow: 0 0 0 1000px #fff inset;
    background-color: #fff;
}

.course-form ::v-deep .ant-input-affix-wrapper .ant-input{
  background-color: #fff;
}

.course-form ::v-deep .ant-input:-webkit-autofill {
    box-shadow: 0 0 0 1000px #fff inset;
    background-color: #fff;
}
.course-form ::v-deep  .ant-input:hover, input:focus {
    box-shadow: 0 0 0 1000px #fff inset;
    background-color: #fff;
}
.course-form ::v-deep  .ant-input{
  height: 30px;
}
.course-form ::v-deep .ant-input::selection{
  background-color: #fff;
}

.course-form ::v-deep .ant-input-suffix{
  display: none;
}
.shelter{
  position: absolute;
    width: 30px;
    height: 30px;
    background-color: #fff;
    top: -6px;
    right: 2px;
}
.errGrade {
  margin-top: 2px;
  width: 30vw;
  height: 16px;
  font-size: 12px;
  color: silver;
  line-height: 14px;
}
.upper-explain {
  height: 0px;
  line-height: 16px;
  color: #f5222d;
}
.noUpper{
  border: 1px solid #f5222d;
}
.noUpper2{
  border: 1px solid #f5222d;
  border-left: none;
  border-right: none;
}
.noUpper3{
  border: 1px solid #f5222d;
  border-left: none;
}
::selection {
  background: #1890ff !important;
  color: #fff !important;
}
.course-info {
  height: 20px;
  line-height: 20px;
  font-size: 14px;
  color: #999
}
</style>
